module.exports = __webpack_public_path__ + "static/flask.cf3d9e18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/technology/img/flask.svg
// module id = 565
// module chunks = 226651268387883